import type { AxiosInstance } from 'axios'
import axiosClient from 'axios'
import type { ApiOptions } from '~/types/util'

export default defineNuxtPlugin(nuxtApp => {
    const runtimeConfig = nuxtApp.$config
    const apiHost = runtimeConfig.public.apiHost as string

    const api = (options: ApiOptions = {}) => {
        options.headers = options.headers || {
            'Content-Type': `application/json`,
            'Accept': `application/json`,
            'API-Version': `2024-07-31`
        }

        if (options.version) {
            options.headers[`API-Version`] = options.version
        }

        const axios: AxiosInstance = axiosClient.create({
            baseURL: apiHost,
            headers: options.headers
        })

        return axios
    }

    return {
        provide: {
            api: api
        }
    }
})
